document.addEventListener('input', (event) => {
  if (!event.target.matches('input[name="attributes[Telefono]"]')) return;

  document.querySelectorAll('input[name="attributes[Telefono]"]').forEach((input) => {
    if (input !== event.target) input.value = event.target.value;
  });
});

document.addEventListener('click', async (event) => {
  const checkoutLink = event.target.closest('[data-required-phone-form]');
  if (!checkoutLink) return;

  const form = document.getElementById(checkoutLink.dataset.requiredPhoneForm);
  const phoneInput = form?.elements.namedItem('attributes[Telefono]');
  if (!phoneInput || !phoneInput.reportValidity()) {
    event.preventDefault();
    phoneInput?.focus();
    return;
  }

  event.preventDefault();
  checkoutLink.setAttribute('aria-disabled', 'true');
  checkoutLink.setAttribute('disabled', 'disabled');

  try {
    const response = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        attributes: {
          Telefono: phoneInput.value.trim(),
        },
      }),
    });

    if (!response.ok) throw new Error('Phone could not be saved');
    window.location.assign(checkoutLink.href || '/checkout');
  } catch (error) {
    checkoutLink.removeAttribute('aria-disabled');
    checkoutLink.removeAttribute('disabled');
    console.error(error);
  }
});
